import omit from 'lodash/omit';

import {
  ProjectGeoDataByIri,
  ProjectGeoDataProperty,
} from 'src/constants/projectGeoData';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setGeoDataForIri =
  (iri: string, geoData: ProjectGeoDataByIri) => (model: Model) => {
    setDataProperty<ModelData>(model)(model.modelData, 'geoDataByIri', {
      ...model.modelData.geoDataByIri,
      [iri]: geoData,
    });
  };

export const updateGeoDataPropertyForIri =
  (
    iri: string,
    propertyKey: keyof ProjectGeoDataByIri,
    propertyValue: ProjectGeoDataProperty | undefined
  ) =>
  (model: Model) => {
    const currentGeoData = model.modelData.geoDataByIri[iri] || {};

    const updatedGeoData = propertyValue
      ? { ...currentGeoData, [propertyKey]: propertyValue }
      : omit(currentGeoData, propertyKey);

    if (Object.keys(updatedGeoData).length === 0) {
      // Remove the entire entry if no geo data properties exist
      setDataProperty<ModelData>(model)(
        model.modelData,
        'geoDataByIri',
        omit(model.modelData.geoDataByIri, iri)
      );
    } else {
      setDataProperty<ModelData>(model)(model.modelData, 'geoDataByIri', {
        ...model.modelData.geoDataByIri,
        [iri]: updatedGeoData,
      });
    }
  };

export const removeGeoDataForIri = (iri: string) => (model: Model) => {
  if (model.modelData.geoDataByIri[iri] !== undefined) {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'geoDataByIri',
      omit(model.modelData.geoDataByIri, iri)
    );
  }
};
